import AbstractService from "./Abstract.service";

export default class AnnouncementService extends AbstractService
{
    listing(): Promise<any>
    {
        return this.get(`/annouce`);
    }

    add(payload:Object): Promise<any>
    {
        return this.post(`/annouce`,payload);
    }

    update(payload:Object): Promise<any>
    {
        return this.put(`/annouce`,payload);
    }

    del(payload:Object): Promise<any>
    {
        return this.delete(`/annouce`,payload);
    }
}